export default "/images/vendor/flag-icon-css/flags/1x1/mp.svg?669fb6af01d040686c75ea576884e423";